import React__default from 'react';
import MessageAudioPart from '../../MessageAudioPart/index.js';
import MessageTextPart from '../../MessageTextPart/index.js';
import MessageHyperLinkTextPart from '../../MessageHyperLinkTextPart/index.js';
import MessageImagePart from '../../MessageImagePart/index.js';
import MessageVideoPart from '../../MessageVideoPart/index.js';
import MessageFilePart from '../../MessageFilePart/index.js';
import ErrorMessage from '../ErrorMessage/index.js';
import styles from './styles.css.js';

var CarouselMessage = function CarouselMessage(_a) {
  var message = _a.message,
      onLoaded = _a.onLoaded,
      myself = _a.myself,
      onError = _a.onError;
  return React__default.createElement("div", {
    className: styles.carouselContainer
  }, React__default.createElement("div", {
    className: styles.carousel
  }, message.parts.map(function (part, idx) {
    switch (part.type) {
      case 'IMAGE':
        return React__default.createElement(MessageImagePart, {
          part: part,
          key: idx,
          onLoaded: onLoaded,
          myself: myself
        });

      case 'VIDEO':
        return React__default.createElement(MessageVideoPart, {
          part: part,
          key: idx,
          onLoaded: onLoaded,
          myself: myself
        });

      case 'AUDIO':
        return React__default.createElement(MessageAudioPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'TEXT':
      case 'TEMPLATE':
      case 'SHORTENED_TEMPLATE':
      case 'TEMPLATE_TEXT':
        return React__default.createElement(MessageTextPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'HYPERLINK_TEXT':
        return React__default.createElement(MessageHyperLinkTextPart, {
          part: part,
          key: idx,
          myself: myself
        });

      case 'TEMPLATE_CAROUSEL':
        return null;

      case 'FILE':
        return React__default.createElement(MessageFilePart, {
          part: part,
          key: idx,
          myself: myself
        });

      default:
        return React__default.createElement(ErrorMessage, {
          message: message,
          onError: onError,
          onLoaded: onLoaded,
          key: idx,
          myself: myself
        });
    }
  })));
};

CarouselMessage.handlesMessage = function (message) {
  return message.parts.length > 1;
};

export default CarouselMessage;
//# sourceMappingURL=index.js.map
